<template>
  <td class="pr-4">
    <h6 class="custom-margin-h6-table">
      <strong>{{ $t('sigatoka.ages_to_evaluate') }}:</strong>
    </h6>

    <div>
      <div v-for="age in ages" :key="age">
        <div v-if="age === 0">
          {{ $t('sigatoka.expecting') }}
        </div>
        <div v-else-if="age === 1">
          {{ $t('sigatoka.newly_given_birth') }}
        </div>
        <div v-else>{{ age }} {{ $t('common_words.weeks') }}</div>
      </div>
    </div>
  </td>
</template>
<script>
export default {
  name: 'info-ages',
  props: {
    ages: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
